var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.494 4.246a.849.849 0 000 1.186l3.75 3.813H3.825a.832.832 0 00-.825.838c0 .464.37.84.825.84h10.297l-3.586 3.645a.849.849 0 000 1.186.815.815 0 001.166 0l5.056-5.14a.849.849 0 00-.04-1.228l-5.057-5.14a.816.816 0 00-1.167 0z",
    clipRule: "evenodd"
  })));
}

export default SvgArrowRight;